export const VUEX_CONTENT_CONTAINER_SET_PROPS = 'VUEX_CONTENT_CONTAINER_SET_PROPS'
export const VUEX_CONTENT_CONTAINER_SET_STYLES = 'VUEX_CONTENT_CONTAINER_SET_STYLES'
